import HttpService from "./htttp.service"; // ✅ ensure path is correct

class SnapshotService {
  /**
   * 📊 Generate Market Snapshot (downloads PDF)
   */
  async generateMarketSnapshot(snapshotInfo) {
    try {
      const payload = { snapshotInfo };
      // console.log("📥 [Frontend] Market Snapshot payload:", JSON.stringify(snapshotInfo, null, 2));

      // ✅ Use download() method to receive PDF as blob
      const response = await HttpService.download(`/snapshot/market`, payload);

      const fileUrl = window.URL.createObjectURL(new Blob([response]));
      const link = document.createElement("a");
      link.href = fileUrl;
      link.setAttribute(
        "download",
        `Comparedly-Market-Snapshot-${new Date().toISOString().slice(0, 10)}.pdf`
      );
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(fileUrl);

      console.log("✅ Market Snapshot PDF downloaded successfully.");
    } catch (error) {
      console.error("❌ Error generating Market Snapshot:", error);
      throw error;
    }
  }

  /**
   * 🏷️ Generate Brand Snapshot (downloads PDF)
   */
  async generateBrandSnapshot(snapshotInfo) {
    try {
      const payload = { snapshotInfo };
      console.log("📥 [Frontend] Brand Snapshot payload:", JSON.stringify(snapshotInfo, null, 2));

      const response = await HttpService.download(`/snapshot/brand`, payload);

      const fileUrl = window.URL.createObjectURL(new Blob([response]));
      const link = document.createElement("a");
      link.href = fileUrl;
      link.setAttribute(
        "download",
        `Comparedly-Brand-Snapshot-${new Date().toISOString().slice(0, 10)}.pdf`
      );
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(fileUrl);

      console.log("✅ Brand Snapshot PDF downloaded successfully.");
    } catch (error) {
      console.error("❌ Error generating Brand Snapshot:", error);
      throw error;
    }
  }

  /**
   * 🎥 Generate Content Snapshot (downloads PDF)
   */
  async generateContentSnapshot(snapshotInfo) {
    try {
      const payload = { snapshotInfo };
      console.log("📥 [Frontend] Content Snapshot payload:", JSON.stringify(snapshotInfo, null, 2));

      const response = await HttpService.download(`/snapshot/content`, payload);

      const fileUrl = window.URL.createObjectURL(new Blob([response]));
      const link = document.createElement("a");
      link.href = fileUrl;
      link.setAttribute(
        "download",
        `Comparedly-Content-Snapshot-${new Date().toISOString().slice(0, 10)}.pdf`
      );
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(fileUrl);

      console.log("✅ Content Snapshot PDF downloaded successfully.");
    } catch (error) {
      console.error("❌ Error generating Content Snapshot:", error);
      throw error;
    }
  }

  /**
   * 📢 Generate Campaign Snapshot (downloads PDF)
   */
  async generateCampaignSnapshot(snapshotInfo) {
    try {
      const payload = { snapshotInfo };
      console.log("📥 [Frontend] Campaign Snapshot payload:", JSON.stringify(snapshotInfo, null, 2));

      const response = await HttpService.download(`/snapshot/campaign`, payload);

      const fileUrl = window.URL.createObjectURL(new Blob([response]));
      const link = document.createElement("a");
      link.href = fileUrl;
      link.setAttribute(
        "download",
        `Comparedly-Campaign-Snapshot-${new Date().toISOString().slice(0, 10)}.pdf`
      );
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(fileUrl);

      console.log("✅ Campaign Snapshot PDF downloaded successfully.");
    } catch (error) {
      console.error("❌ Error generating Campaign Snapshot:", error);
      throw error;
    }
  }

  /**
   * 📧 Email Snapshot
   */
  async emailSnapshot(snapshotInfo, recipients) {
    try {
      const payload = { snapshotInfo, recipients };
      return await HttpService.post(`/snapshot/email`, payload);
    } catch (error) {
      console.error("❌ Error emailing snapshot:", error);
      throw error;
    }
  }

  /**
   * 🔗 Get Signed Download Link for a Snapshot Run
   */
  async getSnapshotRunDownloadLink(snapshotId, runIndex) {
    try {
      const response = await HttpService.get(`/snapshot/run-download/${snapshotId}/${runIndex}`);
      return response.url;
    } catch (error) {
      console.error("❌ Error fetching snapshot run download link:", error);
      throw error;
    }
  }

  /**
   * 👀 Preview Snapshot (returns a blob URL)
   */
  async previewSnapshot(snapshotInfo) {
    try {
      const payload = { snapshotInfo };
      const type = (snapshotInfo.snapshotType || "market").toLowerCase();
      const response = await HttpService.download(`/snapshot/${type}`, payload);

      const fileBlob = new Blob([response], { type: "application/pdf" });
      const fileUrl = window.URL.createObjectURL(fileBlob);
      return fileUrl;
    } catch (error) {
      console.error("❌ Error previewing snapshot:", error);
      throw error;
    }
  }
}

export default new SnapshotService();
